import React,{useState} from 'react'
import { NavLink, useNavigate, useHref } from 'react-router-dom'
import BeforeLoginHeader from '../header/BeforeLoginHeader'
import {OTPRequest} from '../../redux/reducer/FetchDataReducer'
import { useSelector, useDispatch } from 'react-redux'
import Loader from '../../utils/Loader'
import { toast } from 'react-toastify';
let status = ''


const ForgotPassword = () => {
  const [username, setusername] = useState('')

  let navigate = useNavigate();
  const dispatch = useDispatch()

  const fetchReducer = useSelector((state) => state.fetchDataReducer)



  const VerifyOtp = () =>{
    let reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w\w+)+$/;

   if (reg.test(username) === false) {
    toast.error('Email should be proper!');
    } else {
        let obj = {
            email: username,
        }
    
        dispatch(OTPRequest({obj:obj, navigate:navigate}))
    }

}


// if(status == '' || status != fetchReducer.status){
//   switch(fetchReducer.status){
//     case 'FetchDataReducer/OTPRequest':
//       status = fetchReducer.status;
//       break;
//     case 'FetchDataReducer/OTPSuccess':
//       status = fetchReducer.status;
//       navigate("/otp", { replace: true });
//       break;
//   }
// }

 
 





  return (
    <>
    <div className='top-b-header'>
      <NavLink to="/login">
      <i className="fa-solid fa-arrow-left"></i>
      </NavLink>
    
      <h3>Forgot Password</h3>
      <div></div>
  </div>
  
    <div className='container'>
    <Loader visible={fetchReducer.isloading} />
    <div className='forgot-screen'>
        <img src='images/email-icon.png'/>
        <h3>Enter Your Email</h3>
        <p>We will send a 4 digit OTP to your email address to reset your password.</p>
        <div className='form-group'>
          <input type="email" className='form-control' placeholder='Email Here'
          value={username}
          onChange={(e)=>setusername(e.target.value)}
          />
        </div>
        <div className='form-group'>
                <button type='button' className='login-btn' onClick={VerifyOtp}>NEXT</button>
            </div>
    </div>
    </div>
   
    </>
  )
}

export default ForgotPassword